<template>
  <div>
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-icon v-bind="attrs" v-on="on">mdi-dots-vertical</v-icon>
      </template>
      <v-list>
        <v-list-item>
          <v-btn :disabled="!$auth.policies['update-teaching']" class="elevation-0" icon @click="editState = !editState">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </v-list-item>
        <v-list-item>
          <v-btn :disabled="!$auth.policies['delete-teaching']" class="elevation-0" icon @click="deleteState = true">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-list-item>
      </v-list>
    </v-menu>

    <TeachingEditDialog
      :state="editState"
      :selectedTeaching="selectedTeaching"
      @done="$emit('updateDone', selectedTeaching)"
    />
    <TeachingDeleteDialog :state="deleteState" @delete="onDelete" @closeDialog="deleteState = false" />
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import TeachingEditDialog from '@/modules/teacher/TeachingEditDialog.vue'
import TeachingDeleteDialog from '@/modules/teacher/TeachingDeleteDialog'
import { Teaching } from '@/plugins/api'

export default {
  components: {
    TeachingEditDialog,
    TeachingDeleteDialog
  },
  props: {
    selectedTeaching: { type: Object, default: () => {} }
  },
  data() {
    return {
      sending: null,
      editState: false,
      deleteState: false
    }
  },
  computed: {},
  methods: {
    ...mapActions('teaching', ['removeTeaching', 'updateTeaching']),

    async onDelete() {
      this.$loading.active = true
      try {
        const teachings = await Teaching.fetch({
          class: this.selectedTeaching.class.id,
          subject: this.selectedTeaching.subject.id,
          _limit: 2
        })
        if (teachings && teachings.length === 1) {
          // update teaching
          this.updateTeaching({ id: this.selectedTeaching.id, teacher: null })
        } else if (teachings && teachings.length === 2) {
          // remove teaching
          await this.removeTeaching(this.selectedTeaching.id)
        }
        this.$alert.success('Xoá thành công!')
        this.deleteState = false
        this.$emit('updateDone', this.selectedTeaching)
      } catch (error) {
        console.error(error)
        this.$alert.deleteError()
      } finally {
        this.$loading.active = false
      }
    }
  }
}
</script>
